import { QIcon_chevron_right } from '@repo/icons/index'
import classNames from 'classnames'
import { ReactNode } from 'react'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { COLORS } from '../../../../modules/vars'

interface ArrowLinkBoxType {
  title: string | React.ReactFragment | React.ReactElement
  subtitle?: string | React.ReactFragment | React.ReactElement
  subText?: string
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  children?: ReactNode
  active?: boolean
}

const ArrowLinkBox = ({ title, subtitle, onClick, children, active }: ArrowLinkBoxType) => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className={styles.container(active)} onClick={onClick}>
        <div>
          <div className="mb-[4px] flex items-center justify-between">
            <h5>{title}</h5>
            <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY600} />
          </div>
          <h3 className="text-h5 text-black">{subtitle}</h3>
        </div>
        {active && <hr className="my-[12px]" />}
        {children}
      </div>
    )
  } else {
    return (
      <div className={styles.container_pc(active)} onClick={onClick}>
        <div>
          <div className="mb-[4px] flex items-center justify-between">
            <h5>{title}</h5>
            <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY600} />
          </div>
          <h3 className="text-h5 text-black">{subtitle}</h3>
        </div>
        {active && <hr className="my-[12px]" />}
        {children}
      </div>
    )
  }
}

const styles = {
  container: (active: boolean) =>
    classNames(
      `mb-[8px] rounded-[6px] p-[16px] shadow-sm`,
      active ? `bg-white` : `bg-gray-100`,
      active ? `border border-gray-100` : ``
    ),
  container_pc: (active: boolean) =>
    classNames(
      `h-[198px] w-full cursor-pointer overflow-hidden rounded-[5px] p-[16px] shadow-sm xl:w-[336px]`,
      active ? `bg-white` : `bg-gray-100`,
      active ? `border border-gray-100` : ``
    ),
}

export default ArrowLinkBox
